import { Reveal } from "@/components/Reveal";

export default function SectionHeader({ eyebrow, title, description, dark = false, center = false }) {
  return (
    <div className={`max-w-3xl ${center ? "mx-auto text-center" : ""}`} data-testid="section-header">
      <Reveal>
        <div className={`flex items-center gap-4 ${center ? "justify-center" : ""}`}>
          <span className="h-px w-10 bg-gold" />
          <span className="eyebrow">{eyebrow}</span>
          {center && <span className="h-px w-10 bg-gold" />}
        </div>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className={`mt-5 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-tight ${dark ? "text-white" : "text-oxford"}`}>
          {title}
        </h2>
      </Reveal>
      {description && (
        <Reveal delay={0.16}>
          <p className={`mt-5 text-base leading-relaxed ${dark ? "text-steel" : "text-carbon/70"}`}>{description}</p>
        </Reveal>
      )}
    </div>
  );
}
